// servicesBills brand tokens — single source for palette/type/shape.
// Identity: a trustworthy billing/subscription SaaS. Deep teal (stability/money)
// with a warm amber accent for calls-to-action, on cool slate neutrals.
export const brand = {
  name: "servicesBills",
  colors: {
    primary:   { main: "#0F766E", dark: "#115E59", light: "#5EEAD4", contrastText: "#FFFFFF" },
    secondary: { main: "#F59E0B", dark: "#B45309", light: "#FCD34D", contrastText: "#1F2937" },
    success: "#16A34A",
    error:   "#DC2626",
    warning: "#D97706",
    info:    "#0284C7",
    bg:      "#F8FAFC",
    paper:   "#FFFFFF",
    textPrimary:   "#0F172A",
    textSecondary: "#475569",
  },
  fontFamily: '"Inter", "Segoe UI", Roboto, system-ui, -apple-system, sans-serif',
  radius: 10,
};
